import { render, staticRenderFns } from "./PrivacyPortalCategory.vue?vue&type=template&id=1c032aed&scoped=true"
import script from "./PrivacyPortalCategory.vue?vue&type=script&lang=js"
export * from "./PrivacyPortalCategory.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPortalCategory.vue?vue&type=style&index=0&id=1c032aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c032aed",
  null
  
)

export default component.exports